import { render, staticRenderFns } from "./roi.vue?vue&type=template&id=34d4c98d&scoped=true"
import script from "./roi.vue?vue&type=script&lang=js"
export * from "./roi.vue?vue&type=script&lang=js"
import style0 from "./roi.vue?vue&type=style&index=0&id=34d4c98d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4c98d",
  null
  
)

export default component.exports